import React, { memo } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import classNames from 'classnames';

import styles from './styles.js';

const useStyles = createUseStyles(styles, 'Layout');

const Layout = ({ children, className, overrides }) => {
    const classes = useStyles();

    return (
        <div className={classNames(classes.root, className)}>
            <div className={classes.children} {...overrides?.children}>
                {children}
            </div>
        </div>
    );
};

export default memo(Layout);
